import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import './NotFound.sass'

const NotFound = () => {
  return (
    <div id="not-found" className="page">
      <div className="logo" />
      <section id="intro">
        <div className="illustration" />
        <h1>404</h1>
        <h2><FormattedMessage id="not-found.title" /></h2>
        <Link className="button filled" to="/">
          <FormattedMessage id="go-home" />
        </Link>
      </section>
    </div>
  )
}

export default NotFound
